import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-le",
  "use": "icon-le-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-le\"><path d=\"M63.78 533.53l405.11-165.2-0.05-68.76L63.81 464.18l-0.03 69.35z\" fill=\"#2c2c2c\" p-id=\"1493\" /><path d=\"M63.78 533.53l405.09 172.96v-69.52L63.81 464.18l-0.03 69.35zM575.01 561.14h383.87v63.79H575.01zM575.01 392.14h383.87v63.79H575.01z\" fill=\"#2c2c2c\" p-id=\"1494\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol